export default __webpack_public_path__ + "assets/3bc7e06f010ae50ac75eca393301e62f.eot";